import { Alert } from '@mantine/core';

export const PROVIDER_ABSENT_TEXT = 'Your provider has left the call. You can stay — they may rejoin.';
export const PROVIDER_LATE_TEXT = "Your provider hasn't joined yet.";

/** Client and guest call screens while `providerPresent` is false; the call stays connected. */
export function ProviderAbsentNotice(): JSX.Element {
  return (
    <Alert color="yellow" variant="white" mx="md" mt="sm">
      {PROVIDER_ABSENT_TEXT}
    </Alert>
  );
}

/** Waiting screens once `start` is 15 minutes past and no provider has joined (`providerLate`). */
export function ProviderLateNotice(): JSX.Element {
  return (
    <Alert color="yellow" w="100%">
      {PROVIDER_LATE_TEXT} You can keep waiting.
    </Alert>
  );
}
